import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import { useCheckForwardAccumulatorByTradeCapture } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';

const DeleteIcon = ({ legId }: { legId: string }) => {
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleDelete = () => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Schedule line deleted', legId);
    return check({
      schedule: { [legId]: null },
    });
  };
  return (
    <button type="button" className="btn btn-sm btn-link btn-icon mx-1" data-e2e="delete" onClick={handleDelete}>
      <i className="icon icon-sm">delete_outline</i>
    </button>
  );
};

export default DeleteIcon;
